import React, { useState } from 'react';

import { PlacementCardWrapper } from './style';

const PlacementCard = ({
  cardsData,
  activePlacementIndex,
  selectPlacementOption
}) => {

  return (
    <PlacementCardWrapper>
      {cardsData.map((item, index) => (
        <div
          key={item.id}
          className={`item-wrapper ${activePlacementIndex === index ? 'active' : ''}`}
          onClick={() => selectPlacementOption(index)}
        >
          {/* <div className='items'>
            <p>Placement Option</p>
            <p>{item.placementOption}</p>
          </div> */}
          <div className='items'>
            <p>Shipments</p>
            <p>{item.shipments}</p>
          </div>
          {/* <div className='items'>
            <p>Discount</p>
            <p>${item.discounts?.reduce((total, fee) => total + (fee?.value?.amount || 0), 0) || 0}</p>
          </div> */}
          <div className='items'>
            <p>Expiry</p>
            <p>{item.expiry}</p>
          </div>
          <div className='items'>
            <p>Placement Fee</p>
            <p>${item?.placementFee}</p>
          </div>
        </div>
      ))}
    </PlacementCardWrapper>
  );
};

export default PlacementCard;
